import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Label, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChevronDown,
    faChevronUp,
} from '@fortawesome/free-solid-svg-icons';
import SubtotalItem from "./SubtotalItem";
import { formatNumber } from '../../Utils'
import BonusField from './BonusField';
import { withTranslation } from 'react-i18next';


class ShoppingCartTotals extends Component {
    state = {
        collapse: false
    };

    toggleCollapse = () => {
        this.setState({ collapse: !this.state.collapse })
    };

    render() {
        const { collapse } = this.state;
        const { cartItems, itemsPrice, totalPrice, shippingPrice, domainDiscountApplied, domainDiscountAmount, domainDiscountLabel, t } = this.props;
        const subtotalWithShipping = (itemsPrice || 0) + (shippingPrice || 0);

        return (
            <React.Fragment>
                <Collapse isOpen={this.state.collapse}>
                    <div className='subtotals'>
                        <div className='subtotal-items'>
                            {cartItems.map((item, index) => {
                                return (
                                    <SubtotalItem
                                        key={index}
                                        item={item}
                                        isExpress={this.props.isExpress}
                                        allItems={cartItems}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </Collapse>
                <div className="totals">
                    {/* Cart items. */}
                    <div className="totals-sum">
                        <span>
                            <Label>{t('cart.totals.orderAmount')}</Label>
                        </span>
                        <span />
                        <span className='price-total' onClick={this.toggleCollapse}>
                            {formatNumber(itemsPrice)} CHF &nbsp;
                            <FontAwesomeIcon icon={collapse ? faChevronUp : faChevronDown} />
                        </span>

                    </div>

                    <div className="shipping-cost">
                        <div className="shipping-total">
                            <span>
                                <Label>{t('cart.totals.shippingCosts')}</Label>
                            </span>
                            <span />
                            <span className='price-total'>
                                {formatNumber(shippingPrice)} CHF
                            </span>
                        </div>
                        <div className="shipping-cost-note">
                                <span>{t('cart.totals.shippingNote')}</span>
                            </div>
                    </div>

                    <div className="totals-row totals-row-subtotal-with-shipping">
                        <div className="total-including-shipping">
                            <span>
                                <Label>{t('cart.totals.totalWithShipping')}</Label>
                            </span>
                            <span />
                            <span className='price-total'>
                                {formatNumber(subtotalWithShipping)} CHF
                            </span>
                        </div>
                    </div>

                    {/*Promo and gifts and coupons*/}
                    {/* <div className="gifts">
                        <FinalForm
                            onSubmit={(values) => { return values }}
                            initialValues={{}}

                            render={({
                                form,
                                handleSubmit,
                            }) => (
                                    <Form onSubmit={(event) => handleSubmit(event).then(() => form.reset())}>
                                        <FormGroup>
                                            <Label style={{ display: 'block' }}>Code for Prepaid-/Geschenkkarte/Bon</Label>
                                            <Field
                                                className="prepaid-input"
                                                name="prepaid"
                                                component={TextField}
                                                type="text"
                                                placeholder="Eingeben"
                                            />
                                            <Button className='float-right' style={{ width: 'unset' }}>BESTÄTIGEN</Button>
                                        </FormGroup>
                                    </Form>
                                )}
                        />
                    </div> */}
                    <BonusField />
                    {domainDiscountApplied && domainDiscountAmount > 0 && (
                        <div className="shipping-total totals-row-domain-discount">
                            <span>
                                <Label>{t('cart.totals.domainDiscount', { label: domainDiscountLabel || '' })}</Label>
                            </span>
                            <span />
                            <span className='price-total'>
                                -{formatNumber(domainDiscountAmount)} CHF
                            </span>
                        </div>
                    )}
                    <div className="totals-row totals-row-final-cart">
                        <div className="total-including-shipping">
                            <span>
                                <Label>{t('cart.totals.totalWithShipping')}</Label>&nbsp;
                                <span className="small">{t('cart.totals.inclMwst')}</span>
                            </span>
                            <span />
                            <span className='price-total'>
                                {formatNumber(totalPrice)} CHF
                            </span>
                        </div>
                    </div>
                    <div className="totals-row totals-row-final-checkout">
                        <div className="total-including-shipping">
                            <span>
                                <Label>{t('cart.totals.finalAmount')}</Label>&nbsp;
                                <span className="small">{t('cart.totals.inclMwst')}</span>
                            </span>
                            <span />
                            <span className='price-total'>
                                {formatNumber(totalPrice)} CHF
                            </span>
                        </div>
                    </div>
                </div>


            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    cartItems: state.shoppingCart.items,
    itemsPrice: state.shoppingCart.itemsPrice,
    totalPrice: state.shoppingCart.totalPrice,
    shippingPrice: state.shoppingCart.shippingPrice,
    domainDiscountApplied: state.shoppingCart.domainDiscountApplied,
    domainDiscountAmount: state.shoppingCart.domainDiscountAmount,
    domainDiscountLabel: state.shoppingCart.domainDiscountLabel,
    isExpress: state.shoppingCart.isExpress,
    token: state.auth.token,
    welcomecode: state.shoppingCart.welcomecode
});

export default connect(mapStateToProps)(withTranslation()(ShoppingCartTotals));